import { Component } from "vue-property-decorator";
import Template from "./template.vue";
import FormsMixin from "@/mixins/FormsMixin";
import { Action } from 'vuex-class';
import Header from "@/components/Header/components";
import { CLIENTES } from "@/store/modules/SeleccionCliente/types";
import { Usuario } from "@/store/modules/auth/types";

@Component({
  mixins: [Template],
  components: {
    Header,
  },
})
export default class SeleccionCliente extends FormsMixin {
  @Action("listarClientes", { namespace: "SeleccionCliente" }) listarClientes!: Function;

  public search = "";

  public listadoClientes: Array<CLIENTES> = [];
  public dialogEntrarPedido = false;
  public ClienteSeleccionado: Partial<CLIENTES> = {};

  async mounted() {
    this.$root.$emit("loading", true);    
    const UserLogged: Usuario = JSON.parse(localStorage.getItem('userLogged') || '{}');
    this.listadoClientes = await this.listarClientes({ codcli: UserLogged.id })
    this.$root.$emit("setTitulo", "Seleccione un cliente. [" + this.listadoClientes.length + "]" )
    this.$root.$emit("loading", false);
    window.scrollTo(0, 0);
  }

  onClearSearch() {
    this.search = "";
  }

  get getListadoClientes() {

    if (this.search != "") return this.listadoClientes.filter((cliente: CLIENTES) => {
      return cliente.CODCLI.toLowerCase().includes(this.search.toLowerCase()) || cliente.NOMCLI.toLowerCase().includes(this.search.toLowerCase());
    });
    return this.listadoClientes;
  }

  get totalElementos() {
    return this.listadoClientes.length;
  }

  onClickRow(cliente: CLIENTES) {
    this.dialogEntrarPedido = true;
    this.ClienteSeleccionado = cliente;
  }

  onCloseEmpezarPedido() {
    this.dialogEntrarPedido = false;
    this.ClienteSeleccionado = {};
  }
  onEmpezarPedido() {
    try {
      localStorage.setItem("CliePedido", JSON.stringify(this.ClienteSeleccionado));
      this.$router.push({ name: "venta"});
    } catch (error) {
      this.$root.$emit("loading", false);
    }
  }
}
